import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide notes="Transition to hands-on section" transition="fade" networkBackground="full">
      <div
        className="relative z-10 flex flex-col items-center
      justify-center h-full px-24 py-8 text-center slide-scale-75"
      >
        <h2 className="title mb-8">Aan de slag!</h2>

        <div className="text-2xl">
          <p>Laten we ChatGPT gaan gebruiken</p>
          <p className="mt-4">🚀</p>
        </div>
      </div>
    </Slide>
  );
};
